import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';

export const ToolbarTemplate = ({ leftSide, rightSide }) => {
	return (
		<Grid container width="100%">
			<Grid size={12}>
				<Grid container alignItems="center" justifyContent="space-between">
					<Grid>{leftSide}</Grid>
					<Grid>{rightSide}</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

ToolbarTemplate.propTypes = {
	leftSide: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.number]),
	rightSide: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.number]),
};

export default ToolbarTemplate;
